export default "__VITE_ASSET__BVnBdiif__"